/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AuthPrincipalInfo,
  AuthPrincipalInfo$inboundSchema,
} from "./authprincipalinfo.js";

/**
 * Indication that the Gaia session is pre-authenticated via AgentProxy Mode (aka Local Online Mode).
 */
export type PreauthenticationConfig = {
  /**
   * Comprehensive information about an ATLAS authentication principal.
   */
  principal: AuthPrincipalInfo;
};

/** @internal */
export const PreauthenticationConfig$inboundSchema: z.ZodType<
  PreauthenticationConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  principal: AuthPrincipalInfo$inboundSchema,
});

export function preauthenticationConfigFromJSON(
  jsonString: string,
): SafeParseResult<PreauthenticationConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PreauthenticationConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreauthenticationConfig' from JSON`,
  );
}
